import { JackpotsType, JackpotType } from '../../types';

export const getInHouseJackpotsOrder = (
  jackpots: JackpotsType
): JackpotType[] => {
  return Object.entries(jackpots)
    .sort(
      ([, jackpotInfoA], [, jackpotInfoB]) =>
        jackpotInfoB.order - jackpotInfoA.order
    )
    .map(([jackpotType]) => jackpotType as JackpotType);
};
